<template>
  <button :disabled="button_disabled" class="button-action-1" :class="{'disabled':disabled,'status-0':status===0,'status-1':status===1,'status-2':status===2,'status-3':status===3}">
    <div :class="{'active': status===0}" class="label-container">{{label}}</div>
    <div v-if="status===1" class="loading-container">
      <DataPlaceholder/>
    </div>
    <div v-if="status===2" class="success-container">
      <Checkmark/>
    </div>
    <div v-if="status===3" class="error-container">
      <Error/>
    </div>
  </button>
</template>

<script>
import DataPlaceholder from '@/components/DataPlaceholder.vue'
import Checkmark from '@/components/animations/Checkmark.vue'
import Error from '@/components/animations/Error.vue'

export default {
  name: 'ButtonAction1',
  components: {
    DataPlaceholder,
    Checkmark,
    Error,
  },
  props: {
    label: String,
    disabled: Boolean,
    loading: Boolean,
  },
  data() {
    return {
      error: false,
      success: false,
    }
  },
  computed: {
    button_disabled() {
      if(this.disabled || this.status!==0) {
        return true
      }
      return false
    },
    status() {
      if(this.loading) {
        return 1
      }
      if(this.success) {
        return 2
      }
      if(this.error) {
        return 3
      }
      return 0
    },
  },
  methods: {
    showError() {
      this.error=true
      setTimeout(()=>{
        this.error=false
      }, 1000)
    },
    showSuccess() {
      this.success=true
      setTimeout(()=>{
        this.success=false
      }, 1000)
    },
  }
}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.label-container {
  color: transparent;
  &.active {
    color: inherit;
  }
}
.button-action-1 {
  position: relative;
  font-family: 'Quicksand', sans-serif;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  min-height: 42px;
  border: 1px solid $text_dark;
  cursor: pointer;
  &.status-3 {
    transition: border ease 200ms;
    border: 1px solid $error;
  }
  &:active {
    &:not(.disabled) {
      outline: 1px solid $text_dark;
    }
  }
  &:hover {
    &:not(.disabled) {
      background-color: $text_dark;
      color: $text_light;
    }

  }
  &.disabled {
    color: $disabled_light;
    border-color: $disabled_light;
  }
}
.loading-container {
  position:absolute;
  transform: scale(0.4);
}
.success-container {
  position:absolute;
  color: $text_dark;
  height: 100%;
  width: 100%;
}
.error-container {
  position:absolute;
  height: 100%;
  width: 100%;
}
</style>
